import * as Api from '@ViewModels';
import { useInfiniteQuery } from '@tanstack/react-query';
import { useUserSession } from '../../models/hooks/appStateHooks';

const BASE_API_KEY = 'teamMeetingConfig';

export function useInfiniteTeamMeetingConfigsQuery({ pageSize = 25 }: { pageSize?: number } = {}) {
	const userSession = useUserSession();

	return useInfiniteQuery<Api.IPagedCollection<Api.ITeamMeetingConfig>>({
		queryKey: [BASE_API_KEY, 'infinite', pageSize],
		queryFn: ({ pageParam }) => {
			const queryParams: Record<string, string> = { pageSize: String(pageSize) };
			if (pageParam) queryParams.pageToken = pageParam as string;

			return userSession.webServiceHelper.callAsync<Api.IPagedCollection<Api.ITeamMeetingConfig>>(
				Api.ImpersonationBroker.composeApiUrl({
					queryParams,
					urlPath: 'TeamMeetingConfig',
				}),
				'GET'
			);
		},
		getNextPageParam: lastPage => lastPage.pageToken,
		initialPageParam: '',
	});
}
